"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hrefLinkModule = _interopRequireDefault(require("./hrefLink.module.css"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var mapArrowDirectionToClassName = function mapArrowDirectionToClassName(arrowDirection) {
  if (arrowDirection) {
    return _hrefLinkModule.default["btn-arrow-".concat(arrowDirection)];
  }

  return "";
};

var HrefLink = function HrefLink(props) {
  var id = props.id,
      label = props.label,
      to = props.to,
      arrowDirection = props.arrowDirection;
  var arrowDirectionMapping = mapArrowDirectionToClassName(arrowDirection);
  return _react.default.createElement("a", {
    className: (0, _classnames.default)(_hrefLinkModule.default["custom-href"]),
    href: to
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_hrefLinkModule.default["details-container"])
  }, arrowDirectionMapping && _react.default.createElement("div", null, _react.default.createElement(_arrowRightIcon.default, {
    id: id ? "".concat(id, "_arrow") : null,
    className: (0, _classnames.default)(_hrefLinkModule.default["icon"], _hrefLinkModule.default["icon-arrow"], arrowDirection ? _hrefLinkModule.default["btn-arrow-".concat(arrowDirection)] : "")
  })), _react.default.createElement("span", null, label)));
};

HrefLink.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text of the label */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,

  /** address that user is redirected when clicking the link*/
  to: _propTypes.default.string,

  /** The direction of the arrow */
  arrowDirection: _propTypes.default.oneOf(['left', 'right'])
};
var _default = HrefLink;
exports.default = _default;